var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.publication && _vm.publication.url)?_c('div',{attrs:{"id":"pub"}},[_c('video',{attrs:{"id":"video","src":_vm.publication.url,"controls":""},on:{"play":function($event){return _vm.played()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }